import Router from '@/router'

export default function InstallVueRouter (NetteAjax) {
  // cache ajax results
  return NetteAjax.ext('vue-router', {
    init () {
      // handle clicks on link and pass to vue-router
      window.addEventListener('click', event => {
        // ensure we use the link, in case the click has been received by a subelement
        if (event.button || event.ctrlKey || event.shiftKey || event.altKey || event.metaKey || event.defaultPrevented) {
          return;
        }

        let { target } = event
        while (target && target.tagName !== 'A') target = target.parentNode
        // handle only links that do not reference external resources
        if (!target || (!target.matches("a:not([href*='://']):not([href^='mailto:']):not([href^='tel:']):not([href^='#'])") && !target.matches("a[href^='" + window.location.protocol + "//" + window.location.host + "']")) || !target.href) return
        // don't handle if `target="_blank"` or if download attr is present
        if (target && target.getAttribute) {
          const linkTarget = target.getAttribute('target')
          if (/\b_blank\b/i.test(linkTarget)) return
          if (target.hasAttribute('download')) return
          if (target.hasAttribute('data-ajax-off') && target.getAttribute('data-ajax-off') === 'true') return
        }

        // don't handle same page links/anchors
        const url = new URL(target.href)
        if (window.location.pathname === url.pathname && window.location.search === url.search && url.hash) {
          return
        }

        this.callAjax(target.href, target, event)
      })

      Router.beforeEach((to, from) => {
        console.log('Router.beforeEach 0')

        // do not call when only child route change
        if (from.matched.length > 1 && to.matched[0].name === from.matched[0].name)
          return

        console.log('Router.beforeEach 1', to, from)

        // do not call when only hash change
        if (to.fullPath.substr(0, (to.fullPath.length - to.hash.length)) === from.fullPath.substr(0, (from.fullPath.length - from.hash.length)) && !this.forceUpdateRoute && (to.hash.length || from.hash.length))
          return

        console.log('Router.beforeEach 2')
        
        return this.onRouteWillChange(to, from)
      })
      
      Router.afterEach((to, from, failure) => {
        console.log('Router.afterEach -1', failure)
        if (failure) return

        console.log('Router.afterEach 0')

        // do not call when only child route change
        if (from.matched.length > 1 && to.matched[0].name === from.matched[0].name)
          return

        console.log('Router.afterEach 1')

        // do not call when only hash change
        //if (to.fullPath.substr(0, (to.fullPath.length - to.hash.length)) === from.fullPath.substr(0, (from.fullPath.length - from.hash.length)) && !to.force && (to.hash.length || from.hash.length))
        //  return
        
        if (this.finalize) {
          console.log('Router.afterEach 2')

          this.finalize()
          this.finalize = null
          this.forceUpdateRoute = false
        }
        
      })
    },
    before(settings) {
      // dont handle no router request
      if (!settings.route) return

      console.log('VueRouter.before 1')

      // don't handle same page links/anchors
      if (Router.currentRoute.value.path !== settings.route.path || (settings.route.force && !settings.route.replace)) {
        console.log('VueRouter.before 2')
        Router.push(settings.route)
      
      } else/* if (currentRouteUrl !== settings.url || (settings.route.force && settings.route.replace))*/ {
        if (!settings.route.hash && Router.currentRoute.value.path === settings.route.path && window.location.hash) { // keep hash on replace
          settings.route.hash = window.location.hash
        }

        console.log('VueRouter.before 3')
        this.forceUpdateRoute = settings.route.force = true
        Router.replace(settings.route)
      }
    }
  }, {
    finalize: null,
    forceUpdateRoute: false, // process routes even when url does not change
    req: {}, // path => ajax promise
    callAjax(url, target, event, forceUpdateRoute = null, onSuccess) {
      const route = this.urlToRoute(url)
      let fullPath = this.routeToUrl(route)

      //this.forceUpdateRoute = forceUpdateRoute
      if (forceUpdateRoute || (target.hasAttribute('data-router-force') && target.getAttribute('data-router-force') === 'true')) {
        this.forceUpdateRoute = route.force = true
        route.replace = true
      } else if (target && target.hasAttribute('data-router-push') && target.getAttribute('data-router-push') === 'true') {
        this.forceUpdateRoute = route.force = true
        route.replace = false
      }

      this.req[fullPath] = NetteAjax.ajax({
        url: fullPath,
        route,
        linkData: target.getAttribute('data-link'),
        templateId: target.getAttribute('data-template-id'),
        off: ['redirect'],
        wait: true,
        onSuccess
      }, target, event)
    },
    // create vue router route object
    urlToRoute(href) {
      const url = new URL(href.replace(/\+/g, ' '))
      const to = url.pathname

      const query = {}
      if (url.search) {
        const searchArray = url.search.substring(1).split('&')
        for (let searchTerm in searchArray) {
          searchTerm = searchArray[searchTerm].split('=')
          query[decodeURIComponent(searchTerm[0])] = decodeURIComponent(searchTerm[1])
        }
      }

      return { path: to, query, hash: url.hash }
    },
    // vue route to ajax url
    routeToUrl(route) {
      if (!route.matched) { // route is not resolved
        route = Router.resolve(route)
      }

      if (route.meta.netteRoute) {
        let url = route.meta.netteRoute
        Object.keys(route.params).forEach(k => {
          if (route.params[k] == '') {
            url = url.replace('/<' + k + '>', '')
          } else {
            url = url.replace('/<' + k + '>', '/' + route.params[k]).replace('<' + k + '>', route.params[k])
          }
        })
        return url.replace(/\/\<[A-Za-z0-9]+\>/g, '')
      
      } else if (route.matched.length <= 1) {
        let url = route.path
        const query = []
        Object.keys(route.query).forEach(k => {
          query.push(encodeURIComponent(k) + '=' + encodeURIComponent(route.query[k]))
        })

        if (query.length) {
          url = url + '?' + query.join('&')
        }
        return url
      
      } else {
        return route.matched[0].path
      }
    },
    async onRouteWillChange (to/*, from*/) {
      const path = this.routeToUrl(to)
      
      if (typeof this.req[path] === 'undefined') {
        this.req[path] = NetteAjax.ajax({
          url: path,
          off: ['redirect'],
          wait: true,
        })
      }

      //const responseFinalize = await this.runReq[path]()
      const responseFinalize = await this.req[path]

      if (responseFinalize.data?.presenter?.url && !responseFinalize.data.redirect) {
        const currentUrlRoute = Router.resolve(this.urlToRoute(responseFinalize.data.presenter.url))
        const currentRouteUrl = this.routeToUrl(currentUrlRoute)

        if ((!currentUrlRoute.query.snippetName || currentUrlRoute.query.snippetName === 'Content')
            && currentRouteUrl !== path
            && this.req[path]
            && (currentUrlRoute.matched[0].children.length === 0 || currentUrlRoute.matched[0].path !== to.matched[0].path)
        ) {
          console.log('normalize route to url', currentRouteUrl, path)
          this.req[currentRouteUrl] = this.req[path]
          delete this.req[path]
          // TODO: this sometimes do double render of page -> get rid of it!
          //responseFinalize.finalize()
          return currentUrlRoute
        }
      }
      
      // solve redirects?
      if (responseFinalize && responseFinalize.data.redirect) {
        const redirect = this.urlToRoute(responseFinalize.data.redirect)
        if (redirect.path !== to.path) {
          return redirect
        } else {
          window.location.href = responseFinalize.data.redirect
          return false
        }
      } else if (responseFinalize) {
        this.finalize = responseFinalize.finalize
      } else {
        return false
      }
    }
  })
}
